import { Tag } from 'antd';
import { CSSProperties, FC } from 'react';
import { getServiceVersionLabel } from 'src/constants';

interface ServiceVersionTagProps {
  serviceVersion: number | undefined;
  style?: CSSProperties;
}

const ServiceVersionTag: FC<ServiceVersionTagProps> = ({ serviceVersion, style }) => {
  const label = getServiceVersionLabel(serviceVersion);
  return (
    <Tag color={label === 'v2' ? 'blue' : 'default'} style={style}>
      {label}
    </Tag>
  );
};

export default ServiceVersionTag;
